import { render, staticRenderFns } from "./DigitalMedia.vue?vue&type=template&id=207a57e8&"
import script from "./DigitalMedia.vue?vue&type=script&lang=js&"
export * from "./DigitalMedia.vue?vue&type=script&lang=js&"
import style0 from "./DigitalMedia.vue?vue&type=style&index=0&id=207a57e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports